import { Component, OnInit } from '@angular/core';
import { AnimaltypesService } from 'src/app/services/animaltypes.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-animaltype',
  templateUrl: './animaltype.component.html',
  styleUrls: ['./animaltype.component.scss']
})
export class AnimaltypeComponent implements OnInit {
  public animalTypeId:any;
  public animalType:any;
  public loading:boolean=true;

  constructor(
    private _animalType: AnimaltypesService,
    private _activeRoute: ActivatedRoute,
    private _notify: NotificationService
  ) {
    this.animalTypeId=this._activeRoute.snapshot.paramMap.get('typeId');
  }

  public updateAnimalType(){
    if(this.animalType.name=='') return this._notify.showMessage('Name can not be blank.','OK');
    this._animalType.updateAnimalType(this.animalTypeId, this.animalType.name).subscribe(
      res=>{
        this.animalType=res;
        this._notify.showMessage('Animal Type updated.', 'OK');
      }
    );
  }

  ngOnInit() {
    this._animalType.getAnimalType(this.animalTypeId).subscribe(
      res=>{
        this.animalType=res;
        this.loading=false;
      }
    );
  }

}
